// src/components/Modals/HelpModal.jsx
import { useState } from "react";
import { ModalShell } from "../ModalShell";
import { HELP_SECTIONS } from "../../utils/helpContent";

/**
 * Справочное окно.
 *
 * Двухпанельный layout: слева список разделов, справа контент
 * выбранного. Первый раздел HELP_SECTIONS - открытый по умолчанию.
 *
 * Не использует Tabs: разделов около десятка, в верхней полосе они
 * не поместятся. Список слева - стандарт для справок и документации,
 * у него больше места, и он не «уезжает» при переполнении.
 *
 * Ширина 960px - Modal.max-width по умолчанию рассчитан на формы
 * (640-800), справочнику нужен воздух для двух колонок.
 * Класс .modal-help - только layout, сам ModalShell не знает о
 * нашей раскладке.
 *
 * Сброс скролла при смене раздела - через key на .help-content.
 *
 * Контейнер .help-content имеет собственный overflow-y: auto (см.
 * styles.css, раздел 46), а .modal-help .modal-body - overflow: hidden.
 * Значит окно не скроллится, скроллится именно .help-content, и
 * window.scrollTo здесь бесполезен. Без сброса пользователь читает
 * до низа длинной статьи, кликает на следующий раздел - и попадает
 * в середину чужого контента с прежним scrollTop.
 *
 * key={activeId} заставляет React пересоздать DOM-узел при смене
 * раздела; у свежесозданного scrollTop всегда 0. Это декларативнее
 * ref + useEffect и не даёт лишнего кадра с прокрученным контентом:
 * эффект сработал бы после paint, key - до. Пересоздание узла здесь
 * бесплатно: содержимое разделов - статические JSX-константы из
 * helpContent.jsx, терять нечего (ни формы, ни позиции курсора,
 * ни внутреннего состояния).
 */
export function HelpModal({ onClose }) {
  const [activeId, setActiveId] = useState(HELP_SECTIONS[0]?.id || null);
  const active =
    HELP_SECTIONS.find((s) => s.id === activeId) || HELP_SECTIONS[0];

  const footer = (
    <div className="modal-foot">
      <div className="spacer" />
      <button type="button" className="btn ghost" onClick={onClose}>
        Закрыть
      </button>
    </div>
  );

  return (
    <ModalShell
      title="Справка"
      onClose={onClose}
      width={960}
      className="modal-help"
      footer={footer}
      showSave={false}
    >
      <div className="help-layout">
        <nav className="help-nav" aria-label="Разделы справки">
          {HELP_SECTIONS.map((section) => (
            <button
              key={section.id}
              type="button"
              className={`help-nav-item${section.id === active.id ? " on" : ""}`}
              onClick={() => setActiveId(section.id)}
            >
              {section.label}
            </button>
          ))}
        </nav>
        <div className="help-content" key={activeId}>
          {active.content}
        </div>
      </div>
    </ModalShell>
  );
}
